import { Dispatch, SetStateAction, useEffect } from "react";

import { useMultiFileDragUpload } from "../reuseables/dragUpload.hooks";

export default function MediaFileDrop({ setData }: { setData: Dispatch<SetStateAction<any>> }) {
  const { register, dragState, data } = useMultiFileDragUpload();

  useEffect(() => {
    if (data) {
      setData(data);
    }
  }, [data, setData]);

  let className =
    "w-full h-32 border-4 border-dotted rounded-md flex justify-center items-center text-slate-800 cursor-pointer " + //
    (dragState === "enter" ? "bg-green-400 " : "");

  return (
    <>
      <div className={className} {...register()}>
        Drop Your File Here
      </div>
    </>
  );
}
